<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="History" class="d-icon d-icon--history" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M6 3a.5.5 0 0 1 .5.5v2.191l1.724.862a.5.5 0 0 1-.447.894l-2-1A.5.5 0 0 1 5.5 6V3.5A.5.5 0 0 1 6 3Z" fill="currentColor"/><path d="M8.837 1.89a5 5 0 0 0-6.17.387l-.667.6V1.5a.5.5 0 1 0-1 0V4a.5.5 0 0 0 .5.5H4a.5.5 0 1 0 0-1H2.803l.531-.478a4 4 0 1 1-1.312 3.423.5.5 0 1 0-.994.11A5 5 0 1 0 8.837 1.89Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconHistory',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
